export default __webpack_public_path__ + "static/media/icon_privacy_home_choice_icon-1.df96d96e.svg";